export default "__VITE_ASSET__CymPedUz__"